import React from 'react';
// import AboutUsFormSection from '../components/aboutus-form-section';
// import LoanStepsSection from '../components/loan-steps-section';
// import WhyChooseUs from '../components/whychoose-us';
import AboutMain from '../components/about-main';
import MissionVision from '../components/mission-vision';
import StrategicLayersSection from '../components/strategic-layers';
import EcosystemVerticalsSection from '../components/ecosystem-verticals';
import CoreValuesSection from '../components/core-values';
import SolutionsEcosystem from '../components/our-solutions';
import WhyTrustUs from '../components/why-trust-us';
// import HowItWorks from '../components/how-it-works';
import Achievements from '../components/achievements';
// import Review from '../components/review';
// import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-page">
      {/* Form Section */}
      {/* <AboutUsFormSection /> */}
       {/* <LoanStepsSection /> */}
       {/* <WhyChooseUs /> */}
       {/* <AboutMain /> */}
       <MissionVision />
       <SolutionsEcosystem />
       <StrategicLayersSection />
       <CoreValuesSection />
       <EcosystemVerticalsSection />
       
      <div className="hide-section">
       <WhyTrustUs />
   </div>
       {/* <HowItWorks /> */}
       {/* <Achievements />  */}
       {/* <Review /> */}
    </div>
  );
};

export default AboutUs;
